import { graphql } from 'relay-runtime';

export const CreateStudentTargetFocuses = graphql`
  mutation StudentTargetFocusCreateMutation($input: CreateStudentTargetFocusesInput!) {
    createStudentTargetFocuses(input: $input) {
      studentTargetFocusNode {
        id
        isActive
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const UpdateStudentTargetFocuses = graphql`
  mutation StudentTargetFocusUpdateMutation($input: UpdateStudentTargetFocusesInput!) {
    updateStudentTargetFocuses(input: $input) {
      studentTargetFocusNode {
        id
        otherTargetsBlocked
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

// Ends the active focus for the given users (End focus, US-4/US-5). The payload has no
// `errors` field (unlike create/update), so only transport-level errors are surfaced.
export const EndStudentTargetFocuses = graphql`
  mutation StudentTargetFocusEndMutation($input: EndStudentTargetFocusesInput!) {
    endStudentTargetFocuses(input: $input) {
      studentTargetFocusNode {
        id
        isActive
      }
    }
  }
`;

export const StudentTargetFocuses = graphql`
  query StudentTargetFocusesQuery($filter: StudentTargetFocusesFilterInput) {
    studentTargetFocuses(studentTargetFocusesFilterInput: $filter) {
      id
      isActive
      otherTargetsBlocked
      target {
        id
        targetGroup {
          id
        }
      }
    }
  }
`;

// Student-scoped read of the caller's own active focus (ownership filter on the
// resolver restricts rows to the current student). Used by useStudentActiveFocus.
export const StudentActiveFocus = graphql`
  query StudentTargetFocusActiveQuery($filter: StudentTargetFocusesFilterInput) {
    studentTargetFocuses(studentTargetFocusesFilterInput: $filter) {
      id
      isActive
      focusSeenOn
      otherTargetsBlocked
      target {
        id
        name
        summary
      }
    }
  }
`;

export const MarkStudentTargetFocusSeen = graphql`
  mutation StudentTargetFocusSeenMutation($input: MarkStudentTargetFocusSeenInput!) {
    markStudentTargetFocusSeen(input: $input) {
      studentTargetFocusNode {
        id
        focusSeenOn
      }
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`;

export const StudentTargetFocusClasses = graphql`
  query StudentTargetFocusClassesQuery($isActive: ActiveRecords!) {
    studentTargetFocusClasses(isActive: $isActive) {
      id
      isActive
      targetId
      classId
    }
  }
`;
